import type { JSBResponse } from "metaapp-jsbridge";
import { JSBridge } from "metaapp-jsbridge";
import type { ListenerTypeMap } from "../typings/listenerTypeMap";
import type { GetBaseParamsResult, GetUserInforResult, SyncTypeMap } from "~/typings/syncTypeMap";
import { useConfig } from "~/composables/useConfig";

const { env } = useConfig();
export const jsb: JSBridge<SyncTypeMap, ListenerTypeMap> | undefined = isClient()
  ? new JSBridge({ debug: env !== "PROD" })
  : undefined;

/**
 * 获取基本参数简写 V2
 * @returns {Promise<GetBaseParamsResult>}
 */
export async function bpV2() {
  if (jsb?.clientType === false) return;
  return await jsb?.execAsyncDataV2("getBaseParams");
}

/**
 * 隐藏原生标题栏
 * @returns {Promise<GetBaseParamsResult>}
 */
export function hiddenTitle() {
  if (jsb?.clientType === false) return;
  jsb?.execAsyncV2("setNativeTitleShow", "false");
}

/**
 * 设置顶部状态背景颜色
 * @returns {Promise<GetBaseParamsResult>}
 */
export function setStatusColor(color: string) {
  if (jsb?.clientType === false) return;
  jsb?.execAsyncV2("setStatusColor", color);
}

/**
 * 设置顶部状态展示
 * @returns {Promise<GetBaseParamsResult>}
 */
export function setStatusShow(status: boolean) {
  if (jsb?.clientType === false) return;
  jsb?.execAsyncV2("setStatusShow", status);
}

/**
 * 打开新的web页
 * @returns {Promise<GetBaseParamsResult>}
 */
export function openNewWeb(title: string, url: string) {
  if (jsb?.clientType === false) return;
  jsb?.execAsyncV2("openNewWeb", title, url);
}

/**
 * 打开安卓原生页面
 * @returns {Promise<GetBaseParamsResult>}
 */
export function openNative(url: string) {
  if (jsb?.clientType === false) return;
  jsb?.execAsyncV2("openNative", url);
}

/**
 * 复制
 * @returns {Promise<GetBaseParamsResult>}
 */
export function copyText(url: string) {
  if (jsb?.clientType === false) return;
  jsb?.execAsyncV2("copyTextToClipboard", url);
}

/**
 * 检测是否需要完善账号弹窗
 * @returns {Promise<GetBaseParamsResult>}
 */
export async function getNativeAbValue() {
  if (jsb?.clientType === false) return;
  return await jsb?.execAsyncDataV2(
    "getNativeAbValue",
    "control_complete_account",
    "完善账号弹窗",
    "false",
    "boolean"
  );
}

/**
 * 完善账号弹窗
 * @returns {Promise<GetBaseParamsResult>}
 */
export async function goAccountSetting() {
  if (jsb?.clientType === false) return;
  return await jsb?.execAsyncDataV2("goAccountSetting");
}

/**
 * 埋点上报
 * @returns {Promise<GetBaseParamsResult>}
 */
export async function nativeAnalytics(kind, desc = "web埋点", params) {
  if (jsb?.clientType === false) return;
  return await jsb?.execAsyncDataV2("nativeAnalytics", kind, desc, params);
}

/**
 * 实名认证窗口
 * @returns {Promise<GetBaseParamsResult>}
 */
export async function showRealNameAuth(v?: number, param?: string) {
  if (jsb?.clientType === false) return;
  if (v && param) {
    return await jsb?.execAsyncDataV2("showRealNameAuthDialog", v, param);
  } else {
    return await jsb?.execAsyncDataV2("showRealNameAuthDialog");
  }
}

/**
 * 判断环境
 * @returns {Promise<GetBaseParamsResult>}
 */
export async function getVirtualEnv() {
  if (jsb?.clientType === false) return;
  return await jsb?.execAsyncDataV2("isVirtualEnv");
}

/**
 * 获取userInfo
 * @returns {Promise<GetBaseParamsResult>}
 */
export async function getUserInfoVal() {
  if (jsb?.clientType === false) return;
  return await jsb?.execAsyncDataV2("getUserInfo");
}
